export default {
  quoteCommon: {
    close: 'close',
    length: 'length',
    width: 'width',
    height: 'height',
    box_type: 'box type',
    Match_number: 'match number',
    material_type: 'material type',
    flute_type: 'Flute type',
    del_sucess: 'del sucess',
    del_failed: 'del failed',
    cancel_del: 'cancel del',
    copy: 'copy',
    modify: 'modify',
    View: 'View',
    search: 'Search',
    new: 'New',
    Delete: 'Delete',
    pleaseEnter: 'Please enter ',
    Input_format: 'Input format',
    Application_form_number: 'Application form number',
    Estimate_No: 'Estimate No',
    Customer_number: 'Customer number',
    Customer_name: 'Customer name',
    Product_number: 'Product number',
    Product_size: 'Product size',
    Product_name: 'Product name',
    Number_of_products: 'Number of products',
    Please_select: 'Please select',
    Whole: 'Whole',
    Not_approved: 'Not approved',
    Approved: 'Approved',
    Replied: 'Replied',
    No_reply: 'No reply',
    Status: 'Status',
    typeOfGoods: 'Type Of Goods',
    Please_enter_a_keyword: 'Please enter a keyword',
    Please_enter_customer_information_first: 'Please enter customer information first',
    The_user_has_no_permission_to_view_the_quotation_information_of_this_customer: 'The user has no permission to view the quotation information of this customer',
    Details: 'Details',
    Remark: 'Remark',
    Quotation: 'Quotation',
    Template: 'Template',
    Quantity: 'Quantity',
    Dimensional_units: 'Dimensional units',
    Quotation_clerk: 'Quotation clerk',
    Operation: 'Operation',
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    Download: 'Download',
    Upload: 'Upload',
    Molding_size: 'Molding size',
    Sticky_edge: 'Sticky edge',
    Socket: 'Socket',
    Download_the_knife_diagram: 'Download the knife diagram',
    Copy_the_product: 'Copy the product',
    Delete_the_product: 'Delete the product',
    Copy_the_component: 'Copy the component',
    Delete_the_component: 'Delete the component',
    The_format_of_the_molding_dimension_entered_is_wrong: 'The format of the molding dimension entered is wrong',
    The_input_molding_size_is_smaller_than_molding_size_of_the_wooden_box: 'Please note: The molding size entered is smaller than molding size of the wooden box',
    Verification_successful: 'Verification successful',
    Verification_failed: 'Verification failed',
    delete_it_or_not: 'delete it or not',
    tips: 'tips',
    open_version: 'open version',
    open_version_with_hand: 'open version with hand',
    name: 'name',
    Type: 'Type',
    Serial_number: 'Serial number',
    Success: 'Success',
    Preservation: 'Preservation',
    Opportunities: 'Opportunities',
    ReturnReport:'Return Report',
  },
  analyze: {
    title: 'Department/Day/Billing Quantity',
    pitCarton: 'Pit carton',
    bookEdition: 'Book edition',
    colorBox: 'Color box ',
    boutiqueBox: 'Boutique box',
    woodenBox: 'Wooden box',
  },
  bbkPart: {
    Add_Components: 'Add Components',
    Size: 'Size',
    Thickness: 'Thickness',
    Total_PP_number: 'Total PP number',
    PP_number: 'PP number',
    Match_number: 'Match number',
    Couplet: 'Couplet',
    Packing: 'Packing',
    Single_copy: 'Single copy',
    Double_copy: 'Double copy',
    Triple_copy: 'Triple copy',
    Quadruple_copy: 'Five copy',
    Five_copy: '五联本',
    Six_copy: 'Six copy',
    Straightness_book: 'Straightness book',
    Horizontal_book: 'Horizontal book',
    Failed_to_load_the_online_oiling_data_source: 'Failed to load the online oiling data source',
    Total_PP_number_cannot_be_odd: 'Total PP number cannot be odd!',
    The_format_of_the_input_product_size_is_wrong: 'The format of the input product size is wrong!',
    The_layout_size_must_be_larger_than_expanded_size: 'The layout size must be larger than expanded size',
    Paper_size_must_be_larger_than_layout_size: 'Paper size must be larger than layout size',
    Adhesive_binding: 'Adhesive packing',
    Riding_Nail: 'Riding Nail',
    Folding: 'Folding',
  },
  bltPart: {
    Thickness: 'Thickness',
    Blister_type: 'Blister type',
    Skirt: 'Skirt',
    Trimming: 'Trimming',
    Alien: 'Alien',
    Other: 'Other',
    The_format_of_the_input_molding_size_is_wrong: 'The format of the input molding size is wrong!',
  },
  bookCategoryCMPT: {
    Cover: 'Cover',
    Txt_input: 'Txt input',
    Please_enter_an_attribute: 'Please enter an attribute',
    length_1_to_5: '1 to 5 characters in length',
    Please_select_a_value: 'Please select a value',
    Option_one: 'Option one',
    Option_two: 'Option two',
    Radio_box: 'Radio box',
    Check_box: 'Check box',
    Inside_page: 'Inside page',
    Title_page: 'Title page',
  },
  Customer: {
    Account_opening_number_of_the_customer: 'Account opening number of the customer ',
    Account_opening_time: 'Account opening time',
    The_entry_time_cannot_be_later_than_or_equal_to_the_entry_time: 'The entry time cannot be later than or equal to the entry time',
    Query_succeeded: 'Query succeeded',
    Retrieve: 'Retrieve',
    Delete_current_row_data: 'Delete current row data?',
    The_operation_was_canceled: 'The operation was canceled',
  },
  erpQuote: {
    Quotation_number: 'Quotation number',
    Basic_information_of_quotation: 'Basic information of quotation',
    Valuation_Version: 'Valuation Version',
    Several_periods: 'Several periods',
    Tax_included_or_not: 'Tax included or not',
    VAT_rate: 'VAT rate',
    Payment_method: 'Payment method',
    Order_unit: 'Order unit',
    Discount_rate: 'Discount rate',
    Trading_company: 'Trading company',
    Annual_estimated_production_quantity: 'Annual estimated production quantity',
    Quotation_feedback: 'Quotation feedback',
    Quote_version: 'Quote version',
    Feedback_comments: 'Feedback comments',
    Creator: 'Creator',
    Creation_date: 'Creation date',
    Modified_by: 'Modified by',
    Date_of_modification: 'Date of modification',
    Approved_by: 'Approved by',
    Date_of_approval: 'Date of approval',
    Feedback_person: 'Feedback person',
    Feedback_time: 'Feedback time',
    Component: 'Component',
    Component_number: 'Component number',
    Proportioning: 'Proportioning',
    Content: 'Content',
    Quoted_quantity: 'Quoted quantity',
    Number_of_spare_parts: 'Number of spare parts',
    Calculate_the_quantity: 'Calculate the quantity',
    Money: 'Money',
    Sales_Quotation_Unit_Price_Local_currency: 'Sales Quotation Unit Price (Local currency)',
    Cost_amount: 'Cost amount(￥)',
    Cost_unit_price: 'Cost unit price(￥)',
    Additional_costs: 'Additional costs',
    Charge_ratio: 'Charge ratio',
    Actual_receipt: 'Actual receipt',
    Quotation_unit_price: 'Quotation unit price(￥)',
    Profit_margin: 'Profit margin ',
    Suggested_quotation_unit_price_excluding_taxL: 'Suggested quotation unit price (excluding tax)(￥)',
    Suggested_quotation_unit_price_tax_include: 'Suggested quotation unit price (tax included)(￥)',
    Suggested_Quotation_Unit_Price_Local_currency: 'Suggested Quotation Unit Price (Local currency)',
    Actual_profit_margin: 'Actual profit margin',
    Material_cost: 'Material cost',
    Shipping_cost: 'Shipping cost',
    Date_of_valuation: 'Date of valuation',
    Entry_date: 'Entry date',
    Entered_by: 'Entered by',
    Date_of_calculation: 'Date of calculation',
    Tax_rate: 'Tax rate',
    Exchange_rate: 'Exchange rate',
    Missing_estimate_number_parameter: 'Missing estimate number parameter',
    Modification_succeeded: 'Modification succeeded',
    Modification_failed: 'Modification failed',
    Quote_information_is_incomplete_and_cannot_be_saved: 'Quote information is incomplete and cannot be saved',
  },
  quoteQuery: {
    no: 'No',
    pleaseEnter: 'Please enter',
    startDate: 'Start date',
    endDate: 'End date',
    myOrder: 'My order',
    moreConditions: 'More conditions',
    newPitCarton: 'New pit carton',
    businessDepartment: 'Business department',
    creationTime: 'Creation time',
    Created_by: 'Created by',
    Quotation_clerk: 'Quotation clerk',
    Application_status: 'Application status',
    Valuation_status: 'Valuation status',
    Ergonomic_information: 'Ergonomic information',
    Inquiry_information: 'Inquiry information',
  },
  reqQuoteMgmt: {
    Preservation: 'Preservation',
    Approval: 'Approval',
    Unlock_the_approval: 'Unlock the approval',
    SendBack: 'Send Back',
    ReturnReasons: 'Return Reasons',
    Please_enter_a_return_reason: 'Please enter a return reason',
    Preview: 'Preview',
    Cost_analysis: 'Cost analysis',
    RealTtimeCosts: 'Real-time costs',
    ReadBOM: 'Read BOM',
    Copy: 'Copy',
    Revision: 'Revision',
    Next_page: 'Next page',
    Previous_page: 'Previous page',
    Page_one: 'Page one',
    Basic_data: 'Basic data',
    Click_to_view_historical_version: 'Click to view historical version',
    Money: 'Money',
    Quality_requirements: 'Quality requirements',
    Safety_standards: 'Safety standards',
    European_Union_2011_65_EU_RoHS2_0: 'European Union 2011/65/EU RoHS2.0',
    EU_Packaging_Directive_94_62_EC: 'EU Packaging Directive 94/62/EC',
    EU_REACH_EC_1907_2006: 'European Union REACH EC/1907/2006',
    Halogen: 'Halogen',
    Phthalate: 'Phthalate',
    Toy_part_migration_element: 'Toy part migration element',
    Consumer_Product_Safety_Act: 'Consumer Product Safety Act',
    Polycyclic_aromatic_hydrocarbons: 'Polycyclic aromatic hydrocarbons',
    Proofing_sheet_No: 'Proofing sheet No',
    Parts_are_quoted_separately: 'Parts are quoted separately',
    Business_Center_Quotation_Recipient: 'Business Center Quotation Recipient',
    Production_Business_Division: 'Production Business Division',
    Quotation_setting: 'Quotation setting',
    One_price: 'One price',
    Step_price: 'Step price',
    Quoted_quantity: 'Quoted quantity',
    Billing_person: 'Billing person',
    Billing_time: 'Billing time',
    Modified_by: 'Modified by',
    Modified_time: 'Modified time',
    Approved_by: 'Approved by',
    Approved_time: 'Approved time',
    Comment_information: 'Comment information',
    Contents_of_the_appraisal_reply: 'Contents of the appraisal reply',
    Enclosure: 'Enclosure',
    Please_add_a_file: 'Please add a file',
    File_name: 'File name',
    Upload_failed: 'Upload failed',
    Appendices_to_the_Valuation_Results: 'Appendices to the Valuation Results',
    No_documents_are_available: 'No documents are available',
    Add_a_product: 'Add a product',
    Assembly: 'Assembly',
    Packing: 'Packing',
    Transportation: 'Transportation',
    Please_select_a_small_operation: 'Please select a small operation',
    The_starting_point: 'The starting point',
    FOB_port: 'FOB port',
    Overseas_ports: 'Overseas ports',
    Overseas_destinations: 'Overseas destinations',
    Delivery_address: 'Delivery address',
    Kilometers: 'Kilometers',
    Select_an_address: 'Select an address',
    Address: 'Address',
    Select_a_customer: 'Select a customer',
    Please_enter_customer_number_or_name_to_search: 'Please enter customer number or name to search',
    Retrieve: 'Retrieve',
    Enter_keywords_to_filter: 'Enter keywords to filter',
    Knife_line_diagram: 'Knife line diagram',
    Download_the_knife_diagram: 'Download the knife diagram',
    Domestic: 'Domestic',
    Hong_Kong: 'Hong Kong',
    Abroad: 'Abroad',
    Bonded_Zone: 'Bonded Zone',
    Customer_name_cannot_be_empty: 'Customer name cannot be empty',
    length1_200: '1 to 200 characters in length',
    length0_200: '0 to 200 characters in length',
    Length_cannot_be_greater_than_20_characters: 'Length cannot be greater than 20 characters ',
    Quantity_cannot_be_blank: 'Quantity cannot be blank',
    Production_business_department_cannot_be_empty: 'Production business department cannot be empty',
    Stone_row: 'Stone row',
    Bridge_head: 'Bridge head',
    Tangxia: 'Tangxia',
    Select_a_product: 'Select a product',
    You_haven_t_saved_yet_Are_you_sure_you_want_to_navigate_away_from_this_page: 'You have not saved yet. Are you sure you want to navigate away from this page?',
    Hint: 'Hint',
    You_do_not_have_permission_to_view_this_page: 'You do not have permission to view this page',
    Outsourcing_category: 'Outsourcing category',
    Is_the_value_you_entered_also_converted_based_on_the_unit_of_measure: 'Is the value you entered also converted based on the unit of measure?',
    Yes: 'Yes',
    No: 'No',
    Products: 'Products',
    the_converted_product_size_is_less_than_1_inch: ' the product size is less than 1 inch after conversion!',
    The_unit_conversion_is_successful: 'The unit conversion is successful!',
    Only_the_unit_is_switched_and_the_input_value_is_not_converted: 'Only switch units, input value has no conversion!',
    N_Plain_packing: 'N Plain packing',
    Virtual_Product_Packaging_and_Transportation: 'Virtual Product - Packaging and Transportation',
    Transportation_charge_based_on_CBM: 'Transportation charge based on CBM',
    Punch_card_board: 'Punch card board',
    The_order_number_does_not_exist: 'The order number does not exist',
    The_internal_material_consultation_sheet_No_issued_in_this_document_is_as_follow: 'The internal material consultation sheet No. issued in this document is as follow',
    The_number_of_the_pre_work_efficiency_consultation_sheet_issued_in_this_sheet_is_as_follows: 'The number of the pre-work efficiency consultation sheet issued in this sheet is as follows',
    Intra_province_transportation_by_CBM: 'Intra-province transportation (by CBM)',
    Primary_Color: 'Primary Color',
    General_college: 'General college',
    White_ink: 'White ink',
    Metal_fluorescent_special: 'Metal/fluorescent special',
    Connect_the_machine_for_oil_passing: 'Connect the machine for oil passing',
    The_maximum_number_of_quote_quantity_lines_is_8: 'The maximum number of quote quantity lines is 8!',
    Upload_succeeded: 'Upload succeeded',
    The_maximum_file_can_be_uploaded_is_10_M: 'The maximum file can be uploaded is 10 M.',
    Deleted_successfully: 'Deleted successfully',
    Delete_failed: 'Delete failed',
    Are_you_sure_to_remove: 'Are you sure to remove',
    Cancel_the_deletion: 'Cancel the deletion',
    Keyword_cannot_be_less_than_4_characters: 'Keyword cannot be less than 4 characters',
    You_do_not_have_permission_to_view_this_customer_quote_information: 'You do not have permission to view customer quote information',
    Delete_this_data: 'Delete this data?',
    The_deletion_was_canceled: 'The deletion was canceled',
    You_do_not_have_permission_to_modify: 'You do not have permission to modify',
    Not_approved_no_revision_required_can_be_modified_and_saved: 'This document has not been approved and does not need to be revised. It can be modified and saved directly',
    error1: 'The current estimate has not been calculated or approved and does not need to be revised. You can directly inform the Valuation Department to unlock it for revision.',
    You_have_no_permission_to_unapprove: 'You have no permission to unapprove',
    error2: 'This document has not been approved and does not need to be unapproved',
    You_do_not_have_approval_authority: 'You do not have approval authority',
    error3: 'This document has been approved. Please unapprove and approve again',
    You_do_not_have_the_right_to_return: 'You do not have the right to return',
    error4: 'This order has not been approved, no need to return',
    Please_set_up_a_quote_recipient_for_the_business_center: 'Please set up a quote recipient for the business center',
    Please_set_up_a_quotation_clerk: 'Please set up a quotation clerk',
    No_operation_selected: 'No operation selected',
    Small_operation_item_is_not_filled_in: 'Small operation item is not filled in',
    Process_parameter_is_required: 'Process parameter is required',
    Brand: 'Brand',
    Gram_weight: 'Gram weight',
    When_selecting_a_paper_pack: 'When selecting a paper pack, ',
    Required: 'Required',
    When_selecting_a_pallet_there_must_be_an_operation_material: 'When selecting a pallet, there must be an operation material',
    When_selecting_a_card_the_card_type_must_be_selected: 'When selecting a card, the card type must be selected',
    Set_to_blank_box_and_select_again: 'Set to blank box and select again',
    Printing_process: 'Printing process',
    If_printing_is_selected_the_printing_color_must_be_filled_in: 'If printing is selected, the printing color must be filled in',
    Printing_is_selected_printing_process_must_be_selected: 'Printing is selected, printing process must be selected',
    Paper_size_die_size: 'Paper size / die size',
    Number_of_opened_papers: 'Number of opened papers',
    Non_numeric_values_appear_in_opening_size_die_size_and_number_of_opening: 'Non-numeric values appear in opening size, die size, and number of opening',
    Number_of_cuts_is_required_and_is_greater_than_0: 'Number of cuts is required and is greater than 0',
    Length_width_and_height_are_empty: 'Length, width and height are empty',
    Length_and_width_are_empty: 'Length and width are empty',
    Material_is_empty: 'Material is empty',
    The_material_ratio_column_data_is_incorrect: 'The material ratio column data is incorrect (the correct value should be: 1, 2, 4) ',
    Size_Long: 'Size-Long',
    Size_wide: 'Size-wide',
    Type_of_material: 'Type of material',
    Paper_stock_type: 'Paper stock type',
    Material: 'Material',
    Is_empty: 'Is empty',
    Please_select_the_opening_information: 'Please select the opening information',
    Pit_paper_information_must_be_selected_for_pit_mounting_process: 'Pit paper information must be selected for pit mounting process',
    The_color_box_shall_not_have_pit_mounting_PA3_and_card_mounting_PA4_processes_at_the_same_time: 'The color box shall not have pit mounting (PA3) and card mounting (PA4) processes at the same time',
    Please_enter_print_color_information: 'Please enter print color information',
    The_basic_primary_colors_are_up_to_4_colors: 'The basic primary colors are up to 4 colors',
    You_have_selected_double_sided_printing_Please_enter_the_correct_color_information_for_the_front_and_back_sides: 'You have selected double-sided printing. Please enter the correct color information for the front and back sides',
    Version_opening_information_is_empty: 'Version opening information is empty',
    Please_select_the_transport_origin: 'Please select the transport origin',
    Please_select_the_shipping_FOB_port: 'Please select the shipping FOB port',
    Please_select_the_overseas_port_of_shipment: 'Please select the overseas port of shipment',
    Please_select_the_overseas_destination_for_shipping: 'Please select the overseas destination for shipping',
    If_you_choose_transportation_you_must_have_the_number_of_kilometers: 'If you choose transportation, you must have the number of kilometers.',
    Modulus_cannot_be_0: 'Modulus cannot be 0',
    Die_size_should_be_greater_than_developed_size_modulus: 'The size of cutting die shall be larger than size of expansion.',
    The_product_size_in_the_manual_is_incorrect: 'The product size in the manual is incorrect.',
    PP_number_of_each_part_of_the_book_cannot_be_an_odd_number: 'PP number of each part of the book cannot be an odd number',
    PP_number_of_each_part_of_the_book_cannot_be_null: 'PP number of each part of the book cannot be null',
    Please_select_the_opening_information_of_each_part_of_the_book: 'Please select the opening information of each part of the book',
    Error_prompt: 'Error prompt',
    Please_fill_in_the_number_of_kilometers_of_transportation: 'Please fill in the number of kilometers of transportation',
    Internal_packing_is_selected_for_packing_and_external_packing_must_be_selected: 'Internal packing is selected for packing, and external packing must be selected.',
    Please_fill_in_the_packing_information: 'Please fill in the packing information',
    You_do_not_have_permission_to_add: 'You do not have permission to add',
    This_document_has_been_approved_Please_unapprove_it_before_saving: 'This document has been approved. Please unapprove it before saving',
    Please_select_a_quality_requirement: 'Please select a quality requirement',
    Please_select_a_product_type: 'Please select a product type',
    Please_enter_a_quote_quantity: 'Please enter a quote quantity',
    Delete_the_unfilled_part_of_material_or_size_and_continue_to_save: 'Delete the unfilled part of material or size, and continue to save',
    After_completion_save_again: 'After completion, save again',
    Saved_successfully: 'Saved successfully',
    The_request_number_is: 'The request number is',
    Please_wait_for_approval: 'Approval in progress, please wait..',
    There_is_a_problem_with_approval_please_refresh_the_page_before_trying: 'There is a problem with the approval, please refresh the page and try again!',
    There_is_an_error_in_cost_pricing: 'There is an error in cost pricing',
    Approved_successfully: 'Approved successfully',
    Relevant_personnel_of_the_Quotation_Department_have_been_informed: 'Relevant personnel of the Quotation Department have been informed',
    Inform_the_Quotation_Department_of_Abnormity: 'Inform the Quotation Department of Abnormity',
    Developer_no_notification_information: 'Developer, no notification information',
    Approval_failed: 'Approval failed',
    Unblock_successfully: 'Unblock successfully',
    Revision_succeeded: 'Revision succeeded',
    Return_succeeded: 'Return succeeded',
    Can_be_saved_and_approved_again: 'Can be saved and approved again',
    Please_complete_the_information_before_saving_it: 'Please complete the nformation before saving it',
    Initializing_data: 'Initializing data……',
    Please_complete_the_data_and_save_it_before_printing: 'Please complete the data and save it before printing',
    You_do_not_have_permission_to_print: 'You do not have permission to print',
    No_product_description: 'No product description',
    Product_description: 'Product description: ',
    Outsourcing: 'Outsourcing',
    Select_the: 'Select the',
    product: 'product',
    Sky_box_tissue: 'Sky box tissue',
    Sky_box_and_grey_board: 'Sky box and grey board',
    Sky_box_lining_paper: 'Sky box lining paper',
    Ground_box_tissue: 'Ground box tissue',
    Floor_box_ash_board: 'Floor box ash board',
    Box_lining_paper: 'Box lining paper',
    Sky_box_ground_box_tissue: 'Sky box & ground box tissue',
    Sky_box_ground_box_ash_plate: 'Sky box & ground box ash plate',
    Sky_box_ground_box_lining_paper: 'Sky box & ground box lining paper',
    Box_cover_paper: 'Box cover paper',
    Grey_plate_of_box_cover: 'Grey plate of box cover',
    Box_cover_lining_paper: 'Box cover lining paper',
    Box_surface_paper: 'Box surface paper',
    Grey_plate_of_box_body: 'Grey plate of box body',
    Box_body_lining_paper: 'Box body lining paper',
    Cover_paper: 'Cover paper',
    Grey_plate_of_outer_box: 'Grey plate of outer box',
    Outer_box_lining_paper: 'Outer box lining paper',
    Inner_box_tissue: 'Inner box tissue',
    Inner_box_ash_plate: 'Inner box ash plate',
    Inner_box_lining_paper: 'Inner box lining paper',
    Outer_cover_inner_box_tissue: 'Outer cover & inner box tissue',
    Outer_box_inner_box_ash_plate: 'Outer box & inner box ash plate',
    Outer_box_inner_box_lining_paper: 'Outer box & inner box lining paper',
    Wood_panel: 'Wood panel',
    Left_side_plate: 'Left side plate',
    Front_plate: 'Front plate',
    Wooden_floor: 'Wooden floor',
    Right_side_plate: 'Right side plate',
    Back_plate: 'Back plate ',
    Face_base_plate: 'Face + base plate ',
    Left_right_side_plate: 'Left + right side plate ',
    Front_back_plate: 'Front + back plate',
    Assemble: 'Assemble',
    Please_select_a_product_first: 'Please select a product first',
    warning1: 'Because the system has a new version release, the new version and the old version of the data will conflict, so can not copy this list!',
    Template: 'Template',
    pitCarton: 'pitCarton',
    Other: 'Other',
    Warning: 'Warning',
    Quote_line_is_not_filled_in: 'Quote line is not filled in',
    Please_select_the_layout_information: 'Please select the layout information',
    Calculate_costs_in_real_time: 'Calculate costs in real time',
    Please_wait_while_the_cost_is_calculated: 'Please wait while the cost is calculated...',
    There_was_a_problem_with_the_calculation_please_refresh_the_page_and_try_again: 'There was a problem with the calculation, please refresh the page and try again!',
    Get_BOM_information: 'Get BOM information',
    BOMNo: 'BOM No.',
    BOMItemNo: 'Customer Material number',
    Please_select_a_customer_first: 'Please select a customer first',
    Please_enter_the_product_name: 'Please enter the product name',
    Please_enter_the_BOM_number_or_customer_part_number: 'Please enter the BOM number or customer part number',
    BOM_information_does_not_exist: 'BOM information does not exist',
    There_is_no_current_product_category_information: 'There is no current product category information',
    Product_information_is_being_obtained_please_wait_for_a_moment_before_operating: 'Product information is being obtained, please wait for a moment before operating',
    Salesperson_makes_his_own_quotation: 'Salesperson makes his own quotation',
    SelectOpportunities: 'Select Business Opportunity',
    Code: 'Code',
    CustName: 'Customer Name',
    FollowUpUser: 'Follow-up person',
    OpportunitiesCode: 'Opportunity Code',
    OpportunityDate: 'Opportunity Date',
    OpportunityStage: 'Opportunity Stage',
    SalesDepartment: 'Sales Department',
    IntendedProducts: 'Intended Products',
    Please_select_a_business_opportunity: 'Please select a business opportunity!',    
    Wrong_size_information: 'Wrong pallet size information',
  },
  generalPackingCMPT: {
    input_email: 'Please enter your email address',
    input_right_email: 'Please enter a valid email address',
    url_null: 'Domain name cannot be empty',
    url: 'Domain name',
    submit: 'Submit',
    addurl: 'Add domain',
    reset: 'Reset',
  },
  wboxPart: {
    Add_Components: 'Add component',
    Download_the_knife_diagram: 'Download knife diagram',
    Copy_product: 'Copy product',
    Del_product: 'Delete product',
    del_sucess: 'Deletion successful',
    cancel_del: 'Deletion cancelled',
    wrong_format: 'Incorrect format for the molding size input!',
  },
  pitPart: {
    name: 'Name',
    Add_Components: 'Add component',
    Copy_product: 'Copy product',
    Del_product: 'Delete product',
    item_code: 'Material code',
    item_name: 'Material name',
    cust_item: 'Customer material',
    box_type: 'Box type',
    black: 'Blank box',
    hasColor: 'Printed',
    colorNum: 'Number of colors',
    bigBackgroud: 'Ground',
    out_de: '(Outer degree)',
    paper_inch: 'Paper size (INCH)',
    knift_inch: 'Knife size (INCH)',
    count: 'Calculate',
    clear: 'Clear',
    hk: 'Horizontal pit',
    model_num: 'Model number',
    z: 'V', // Vertical
    h: 'H', // Horizontal
    kzgs: 'Number of paper sizes',
    zk: 'Crash mouth',
    dt: 'Nail strip',
    db: 'Single brace',
    sb: 'Double brace/multiple braces',
    item_rate: 'Material ratio',
    knift_num: 'Knife number',
    expandsize: 'Opening size',
    countprice: 'Customer pricing',
    formula: 'Area formula',
    knif_size: 'Knife size',
    package: 'Package',
    must_biger1: 'Layout size must be greater than the expanded size',
    must_biger2: 'Paper size must be greater than the layout size',
    selectitemtype: 'Please select the material code',
    selectlengx: 'Please select the shape',
    selectxx: 'Please select the box type',
    inputsizelen: 'Please enter the size - length',
    inputsizewid: 'Please enter the size - width',
    inputopen_sizehig: 'Please enter the expanded size - height',
    inputopen_sizelen: 'Please enter the expanded size - length',
    inputopen_sizewid: 'Please enter the expanded size - width',
    inputkn_sizelen: 'Please enter the knife size - length',
    inputkn_sizewid: 'Please enter the knife size - width',
    inputsizehig: 'Please enter the size - height',
    inautoCount: 'Cannot automatically calculate the expanded size for啤箱 (irregular box), please manually enter the expanded size!',
    countSucess: 'Expanded size: Calculation successful',
    countFail: 'Expanded size: Calculation failed(',
    neterr: 'Expanded size: Calculation network error(',
    serEx: 'Expanded size: Calculation service response error(',
    knifsucce: 'Knife size/model number: Calculation successful',
    kniffail: 'Knife size/model number: Calculation failed(',
    knifnetfail: 'Knife size/model number: Calculation network error(',
    knifserEx: 'Knife size/model number: Calculation service response error(',
    oppsucce: 'Paper size/paper size number: Calculation successful',
    oppfail: 'Paper size/paper size number: Calculation failed(',
    oppnetfail: 'Paper size/paper size number: Calculation network error(',
    oppserEx: 'Paper size/paper size number: Calculation service response error(',
    do_not_less_wid: 'The width of the paper size cannot be less than or equal to the width of the knife size',
    do_not_less_len: 'The length of the paper size cannot be less than the length of the knife size',
    occ: 'Paper size number: Calculation successful',
    p_i_s: 'Please enter the knife size and paper size correctly',
  },
  pbxPart: {
    input_format: 'Input format: 200*100*100',
    format_wrong: 'Incorrect format for the molding size input!',
  },
  packagePart: {
    perweight: 'Single weight',
    countprowei: 'Calculate product quantity',
    minpacksize: 'Minimum package size',
    maxpacksize: 'Maximum package size',
    maxmz: 'Maximum gross weight',
    sys_count: 'System calculation',
    item: 'Material',
    in_box: 'Inner box',
    type: 'Type',
    paper_pack: 'Paper pack',
    inside_size: 'Box internal size',
    pro_size: 'Product packaging size',
    per_pro_size: 'Single product packaging size',
    load: 'Load',
    load_way: 'Loading method',
    lay_way: 'Laying method',
    weight: 'Gram weight',
    band: 'Brand',
    layCount: 'Number of layers',
    perBackNu: 'Number per pack',
    len: 'Length:',
    wid: 'Width:',
    hig: 'Height:',
    len2: 'Length',
    wid2: 'Width',
    hig2: 'Height',
    out_box: 'Outer box',
    card: 'Cardboard',
    totalHight: 'Total height (including feet)',
    perCarWeight: 'Weight per cardboard',
    lx: 'Shape',
    xx: 'Box type',
    add_flag_car: 'Add flat card',
    kezhong: 'Gram weight',
    thick_coefficient: 'Thickness coefficient:',
    num: 'Number',
    b_c: 'Laying length',
    b_k: 'Laying width',
    b_g: 'Laying height',
    tj: 'Recommended',
    tj_box: 'Recommended carton',
    tj_box_list: 'Recommended carton list',
    show_all_result: 'Show all results',
    re_count: 'Recalculate',
    put: 'Lay',
    sz: 'Size',
    perload: 'Per box load',
    w: 'Weight',
    box_num: 'Number of boxes',
    all_cbm: 'Cardboard count',
    car_num: 'Total CBM',
    PalltPreBoxCount: 'Per cardboard load',
    count: 'Calculate',
    perinsidenum: 'Number of inner boxes per box',
    perproductnum: 'Number of products per box',
    knift_car: 'Straight knife card',
    inside_degree: 'Inner degree',
    out_degree: 'Outer degree',
    size_degree: 'Size(',
    length: 'Length',
    width: 'Width',
    hight: 'Height',
    indegree_size: 'Inner degree size',
    box_item_code: 'Reusability box material number',
    per_box_exceed: 'The weight of each box exceeds',
    percarwithin: 'The weight per cardboard should be <=',
    a_pack: 'A Flat packaging',
    b_pack: 'B Vertical packaging',
    wrong_format: 'Incorrect format for the size information input!',
    chose_result: 'Please select the calculation result',
    select_material: 'Please select the carton material information first',
    counting_wait: 'Calculating, please wait!',
    youset_outrange: 'The height size of the cardboard you set exceeds the limit size range(',
    paper: 'Paper wrapping',
    p_hand_in: 'For multiple products, please manually enter the product packaging size!',
    sys_not_set: 'There is no calculation formula set in the system, please manually enter the product packaging size!',
    bjselect: 'Please select the material information of the component',
    se_one: 'Please select at least one type!',
    se_meterial: 'The material of the carton is not selected',
    se_bxtype: 'The box type of the carton is not selected',
    se_size: 'Please enter the product packaging size',
    num_info: 'Please enter the carton quantity information!',
    too_big: 'The paper pack size is too large, the maximum size is: length',
    inwid: 'INCH, width',
    inhigh: 'INCH, height',
    op_will_clear: 'This operation will clear the selected and input content, continue?',
    too_big_outsize: 'The outer box size is too large, the maximum size is: length',
    too_small_outsize: 'The outer box size is too small, the minimum size is: length',
    should_biger_than: 'The outer degree size (length * width * height) should be greater than or equal to (product packaging size length * width * height * number of products per box)',
    hight_size_is: 'Thickness (height) size = Product molding size height =',
    cn_bc: '= Product packaging size length * Laying length +',
    ck_bk: '= Product packaging size width * Laying width +',
    cg_bg: 'Outer degree size height (MM) = Product packaging size height * Laying height * Thickness coefficient +',
    hdxs: '= Product packaging size width * Laying width * Thickness coefficient + ',
    gaodu: 'Outer degree size height (MM) = Product packaging size height * Laying height +',
    remark: '*Note: The above prompt results are only for system calculations. If the actual numerical values are different, it may be due to manual adjustments.',
    size_wid: 'Outer degree size width (MM)',
    Box_tape: 'Box tape',
    Cartons: 'Cartons',
    Pinka: 'Pinka',
    Knife_card: 'Knife card',
    Turnover_box: 'Turnover box',
    Box: 'Box',
    Ground_box: 'Ground box',
    Sky_Box: 'Sky Box',
    One_piece: 'One piece',
    thick_coefficient1: 'Thickness coefficient',
    Auto_size: 'Auto size',
    Number_of_products_per_case: 'Number of products per case',
    Calculation: 'Calculation',
    Weight_per_carton: 'Weight per carton',
    Dimension_of_horizontal_knife_clamp: 'Dimension of horizontal knife clamp',
    Thickness_height_dimension_description: 'Thickness (height) dimension description',
    Thickness_of_pit_paper: 'Thickness of pit paper',
    The_pit_is_high: 'The pit is high',
    Pit_paper: 'Pit paper',
    Layer_paper_press: 'Layer paper press',
    Each_floor: 'Each floor',
    Totally: 'Totally',
  },
  packagePartCTN: {
    paper_pack: 'Paper pack',
    package: 'Load',
    pack_way: 'Loading method',
    Gram_weight: 'Gram weight',
    brand: 'Brand',
    lay_num: 'Number of layers',
    per_bag_num: 'Number per pack',
    Card_board: 'Cardboard',
    click_to_set: 'Click to set the cardboard size information',
    card_size_set: 'Set the card size information.',
    Please_enter_the_pallet_dimensions: 'Please enter the pallet dimensions',
    length: 'Length',
    width: 'Width',
    tohight: 'Total height (including feet)',
    per_board_quantity: 'Number per board',
    card_size: 'Knife card size(',
    num: 'Number',
    b_c: 'Laying length',
    b_k: 'Laying width',
    b_g: 'Laying height',
    perboxnum: 'Number per box',
    itemcode: 'Reusability box material number',
    ddts: 'Number of tape strips',
    length_out: 'The length size of the cardboard you set exceeds the maximum limit size(',
    width_out: 'The width size of the cardboard you set exceeds the maximum limit size(',
    height_out: 'The height size of the cardboard you set exceeds the maximum limit size(',
    paper_box_type_never_chosed: 'The box type of the carton is not selected',
    Limit_the_total_height: 'Limit the total height',
  },
  packagePartBBK: {
    length: 'Length',
    width: 'Width',
    in_box: 'Inner box',
    paper_pack: 'Paper pack',
    package: 'Load',
    lay_way: 'Laying method',
    pack_way: 'Loading method',
    perbox_num: 'Number per box',
    tj: 'Recommended',
    lay: 'Lay',
    size: 'Size',
    load_num: 'Number of loads',
    weight: 'Weight',
    in_size: 'Inner degree size(',
    knif_size: 'Knife card size(',
    a_pack: 'A Flat packaging',
    b_pack: 'B Vertical packaging',
    box_itemno: 'Reusability box material number',
    nodata: 'No data',
    chose_result: 'Please select the calculation result',
    not_exist_instruction: 'No instruction component information exists',
    instruction_item_no: 'Please select the material for the instruction component',
    not_fit_box: 'No suitable carton',
    nerver_chose_type: 'The box type of the carton is not selected',
  },
  outsourcingPart: {
    itemno: 'Material number',
    item_name: 'Material name',
    hole_paper: '(Hole paper)',
    size_length: 'Size length',
    size_width: 'Size width',
    size_height: 'Size height',
    match_rate: 'Matching rate',
    modify: 'Modify',
  },
  fittingPart: {
    fit: 'Kit assembly',
    buy_compoent: 'Outsourcing components',
    itemname: 'Material name',
    add_item: 'Add material',
    itemno: 'Material number',
    able: 'Enable',
    match_rate: 'Matching rate',
    attribute: 'Attribute',
    null_item_name: 'Material name cannot be empty',
  }
}


// WEBPACK FOOTER //
// ./src/views/reqQuote/local/en.js